import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'black',
    overflow: 'hidden',
  },
})

interface Props {
  className?: string
}

export const FeatureContainer: FC<Props> = flowMax(
  addDisplayName('FeatureContainer'),
  addProps(() => ({
    styles: useStyles(),
  })),
  ({ children, className, styles }) => (
    <div className={cx(styles.container, className)}>{children}</div>
  )
)
